import { render, staticRenderFns } from "./SemaforoSLA.vue?vue&type=template&id=1b8fa930&scoped=true"
import script from "./SemaforoSLA.vue?vue&type=script&lang=js"
export * from "./SemaforoSLA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8fa930",
  null
  
)

export default component.exports